import { render } from "./Ga4AccountListPage.vue?vue&type=template&id=78f4334a"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__